import { create } from 'zustand'

export const useAuthStore = create((set) => ({
    status: 'NOT_AUTHENTICATED',// 'checking' | 'authenticated' | 'not-authenticated'
    user: null,
    errorMessage: null,
    session: false,
    onChecking: () => set({
        status : 'CHECKING',
        user : null,
        errorMessage : null
    }),
    onLogin: (state) => set( {
        status:  'AUTHENTICATED',
        user : state,
        errorMessage : null
    }),
    onLogout: (state) => set( {
        status : 'NOT_AUTHENTICATED',
        user : null,
        errorMessage : state
    }),
    clearErrorMessage: () => set( {
        errorMessage : null
    }),
    onSession: (state) => set( {
        session : state
    })
}))